import { ImageOff } from 'lucide-react';
import { useState } from 'react';

import type { MediaRef } from '@/lib/media';
import { cn } from '@/lib/utils';

/** Renders a media asset reference, falling back to an icon when it 404s. */
export function MediaRefImage({ media, className }: { media: MediaRef; className?: string }) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div
        className={cn('flex items-center justify-center bg-muted text-muted-foreground', className)}
      >
        <ImageOff className="size-6" />
      </div>
    );
  }

  return (
    <img
      src={media.url}
      alt=""
      onError={() => setFailed(true)}
      className={cn('object-cover', className)}
    />
  );
}
